import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';

export class AddProblem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      problems: [],
      errorMessage: ''
    };
  }

  checkExisting(val = '') {
    let isVali = true;
    this.state.problems.forEach(item => {
      if (item.text.trim().toLowerCase() === val.trim().toLowerCase()) {
        isVali = false;
      }
    });
    return isVali;
  }

  onEnter(e) {
    if (e.key === 'Enter') {
      this.onAdd();
    }
  }

  onAdd() {

    if (this.problemInput.value.trim() === '') {return;}

    if (!this.checkExisting(this.problemInput.value)) {
      this.setState({ errorMessage: 'Problem already exists' });
      return;
    }

    let problems = this.state.problems;

    problems.push({ id: uuidv4(), text: this.problemInput.value });

    this.setState({ problems: problems });

    this.problemInput.value = '';
  }

  onRemove(e, item) {

    let problems = [];
    this.state.problems.forEach(obj => {
      if (item.id !== obj.id) {
        problems.push(obj);
      }
    });

    this.setState({ problems: problems },() => {
      if (!this.checkExisting(this.problemInput.value)) {
        this.setState({ errorMessage: 'Problem already exists.' });
      } else {
        this.setState({ errorMessage: '' });
      }
    });

  }

  onChange() {
    if (!this.checkExisting(this.problemInput.value)) {
      this.setState({ errorMessage: 'Problem already exists.' });
    } else {
      this.setState({ errorMessage: '' });
    }
  }

  render() {
    return <div className='form-group add-problem'>
      <label>Problem</label>
      <div className='input-group'>
        <input
          maxLength='100'
          type='text'
          ref={ref => { this.problemInput = ref; }}
          placeholder='Problem'
          onKeyPress={this.onEnter.bind(this)}
          className='form-control'
          onChange={this.onChange.bind(this)}/>
        <div className='input-group-btn'>
          <a className='btn btn-primary btn-siteone' onClick={this.onAdd.bind(this)}>Add</a>
        </div>
      </div>
      <span className='cls-danger help-block'>{this.state.errorMessage}</span>
      <ul className='list-group'>
        {this.state.problems.map(item => {
          return <li itemID={item.id} className='list-group-item'>
            <span className='glyphicon glyphicon-remove'
              onClick={(e) => { this.onRemove(e, item); }} />
            {item.text}
          </li>;
        })}
      </ul>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/Items/Components/add-problem.js